import { coerceQueryInput } from './coerceValueForQuery';
import { definedProps } from './definedProps';

export const toAdvancedQueryList = <T extends { [key: string]: unknown }>(data: T) => {
  return definedProps(
    data,
    undefined,
    coerceQueryInput

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  ).map(([_key, value]) => value);
};
